import clg from "functions/log";
import React, { useState, useEffect, useRef, Fragment } from "react";
import ImageGallery, {fullScreen} from "react-image-gallery";

import SkeletonC from "./Skeletons/SkeletonC";

import "assets/css/image-gallery.min.css";

//      @example
//      const images = [
//        original: 'url',
//        thumbnail: 'url',
//      ]
//}

const ImageGalleryC = ( props ) => {

    const galleryRef = useRef(null);

    const numOfImages = props.items.length;

    clg("PORPS:ITEMS:LENGTH:" ,props.items.length)

    const [loadedImages, setLoadedImages] = useState(0);

    const [ loaded, setLoaded ] = useState(false);

    useEffect(() => {
      if( numOfImages === loadedImages ) {
        setLoaded(true);
      }

    }, [loadedImages, numOfImages] )

    //Képre kattintáskor is nyíljon meg a fullscreen mód
    /* useEffect(() => {
      let imageParts = galleryRef.current.imageGallery.current.children[0].querySelectorAll(".image-gallery-image");// [0].querySelector(".image-gallery-slide-wrapper :not(.image-gallery-icon.image-gallery-fullscreen-button)"); 

      clg("IMG PART: ", imageParts);

      imageParts.forEach(element => element.addEventListener("click", function () {
        openFullScreen()
      }));

      return () => {
        imageParts.forEach(element => element.removeEventListener("click", function () {
          openFullScreen()
        }));
      }
    },[galleryRef]); */

    const openFullScreen = () => {
      galleryRef.current.fullScreen();
    }

    const toggleFullScreen = () => {
      galleryRef.current.toggleFullScreen();
    }

    return (
      <Fragment>

        <style jsx>
          {
            `
            .image-gallery-slides {
              min-height:500px;
            }
            `
          }
        </style>

        <div>
          {
            (Array.isArray( props.items ) && props.items.length > 0) && (
              <ImageGallery
                items={ props.items }
                showPlayButton={false}
                onImageLoad={ () => setLoadedImages(loadedImages + 1) }
                additionalClass={ loaded ? "" : "d-none" }
                ref={galleryRef}
                useBrowserFullscreen={false}
                renderFullscreenButton={()=>null}
                /* renderFullscreenButton={
                  () => (
                    <div className="image-gallery-icon image-gallery-fullscreen-button" onClick={() => toggleFullScreen()}>
                      <i className="fas fa-search"></i>
                    </div>
                  )
                } */
              />
            )
          }

        {
          !loaded && (
            <SkeletonC skeletonProps={ { height : 500 } } />
          )
        }
        </div>
      </Fragment>
    )
}

export default ImageGalleryC;